import { TreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDictionaries } from '@/api/hooks';
import { departmentTreeData } from '@/lib/departments';

import { TreeCheckFilter } from './FilterDropdown';

/**
 * Выбор подразделения из дерева оргструктуры — для форм и фильтров.
 * Работает и внутри Form.Item (value/onChange приходят пропсами), и сам по себе.
 */
export function DepartmentSelect(props: TreeSelectProps<number>) {
  const dictionaries = useDictionaries();

  return (
    <TreeSelect<number>
      allowClear
      showSearch
      treeNodeFilterProp="title"
      treeDefaultExpandAll
      popupMatchSelectWidth={360}
      loading={dictionaries.isLoading}
      treeData={departmentTreeData(dictionaries.data?.departments ?? [])}
      {...props}
    />
  );
}

/** Фильтр по подразделениям над таблицей — дерево с галочками, можно несколько. */
export function DepartmentFilter({
  value,
  onChange,
  width = 220,
  placeholder,
}: {
  value: number[];
  onChange: (value: number[]) => void;
  width?: number;
  placeholder?: string;
}) {
  const { t } = useTranslation();
  const dictionaries = useDictionaries();

  return (
    <TreeCheckFilter
      value={value}
      onChange={onChange}
      width={width}
      placeholder={placeholder ?? t('Подразделение')}
      treeData={departmentTreeData(dictionaries.data?.departments ?? [])}
    />
  );
}
